import { __decorate } from 'tslib';
import * as i0 from '@angular/core';
import { ElementRef, Component, Inject, Input, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { mixinFocusEvent, mixinBlurEvent, mixinChangeEvent, mixinFormControl, FadvBaseComponent, createFormControlProvider, Forward, formControlValueInput, formControlDisabledInput, formControlValueOutput, focusEventOutput, blurEventOutput, changeEventOutput, FadvCommonModule } from '@fa-switch-sharedservices/ng-elements/common';
import '@fa-switch-sharedservices/web-elements/components/select/select';
import { FadvMenuModule, FadvMenuComponent, FadvMenuItemComponent } from '@fa-switch-sharedservices/ng-elements/fadv-menu';

class FadvSelectComponent extends mixinFocusEvent(mixinBlurEvent(mixinChangeEvent(mixinFormControl(FadvBaseComponent)))) {
    constructor(el) {
        super(el);
        //The select's name.
        this.name = '';
        //The select's label. Alternatively, you can use the label slot.
        this.label = '';
        this.placeholder = '';
        //The select's help text. Alternatively, you can use the help-text slot.
        this.helpText = '';
        this.valid = false;
        /* This will be true when the control is in an invalid state.
         */
        this.invalid = false;
        /** When true the input will have a floating label, when false the label will be centered able the input */
        this.floating = true;
        //Adds a clear button when the select is populated.
        this.clearable = false;
        //Enable this option to prevent the panel from being clipped when the component is placed inside a container with overflow: auto|scroll.
        this.hoist = false;
        //The maximum number of tags to show when multiple is true. After the maximum, "+n" will be shown to indicate the number of additional items that are selected. Set to -1 to remove the limit.
        this.maxTagsVisible = 3;
        //Enables multiselect. With this enabled, value will be an array.
        this.multiple = false;
        //	The select's required attribute.
        this.required = false;
        this.scrollable = false;
    }
    ngAfterContentInit() {
        this.registerFormValueChangeHandler((value) => (this.elementRef.nativeElement.value = value));
        this.registerSubscription(this.blurred, () => this.onTouched());
        this.registerSubscription(this.changed, () => {
            const value = this.elementRef.nativeElement.value;
            this.reportChange(value);
        });
    }
}
FadvSelectComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvSelectComponent, deps: [{ token: ElementRef }], target: i0.ɵɵFactoryTarget.Component });
FadvSelectComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.3", type: FadvSelectComponent, selector: "fadv-select", inputs: { value: "value", disabled: "disabled", variant: "variant", name: "name", label: "label", placeholder: "placeholder", helpText: "helpText", valid: "valid", invalid: "invalid", floating: "floating", pill: "pill", clearable: "clearable", hoist: "hoist", maxTagsVisible: "maxTagsVisible", multiple: "multiple", required: "required", scrollable: "scrollable", native: "native", breakpoint: "breakpoint" }, outputs: { valueChange: "valueChange", focused: "focused", blurred: "blurred", changed: "changed" }, providers: [createFormControlProvider(FadvSelectComponent)], usesInheritance: true, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
__decorate([
    Forward()
], FadvSelectComponent.prototype, "variant", void 0);
__decorate([
    Forward()
], FadvSelectComponent.prototype, "name", void 0);
__decorate([
    Forward()
], FadvSelectComponent.prototype, "label", void 0);
__decorate([
    Forward()
], FadvSelectComponent.prototype, "placeholder", void 0);
__decorate([
    Forward()
], FadvSelectComponent.prototype, "helpText", void 0);
__decorate([
    Forward()
], FadvSelectComponent.prototype, "valid", void 0);
__decorate([
    Forward()
], FadvSelectComponent.prototype, "invalid", void 0);
__decorate([
    Forward()
], FadvSelectComponent.prototype, "floating", void 0);
__decorate([
    Forward()
], FadvSelectComponent.prototype, "pill", void 0);
__decorate([
    Forward()
], FadvSelectComponent.prototype, "clearable", void 0);
__decorate([
    Forward()
], FadvSelectComponent.prototype, "hoist", void 0);
__decorate([
    Forward()
], FadvSelectComponent.prototype, "maxTagsVisible", void 0);
__decorate([
    Forward()
], FadvSelectComponent.prototype, "multiple", void 0);
__decorate([
    Forward()
], FadvSelectComponent.prototype, "required", void 0);
__decorate([
    Forward()
], FadvSelectComponent.prototype, "scrollable", void 0);
__decorate([
    Forward()
], FadvSelectComponent.prototype, "native", void 0);
__decorate([
    Forward()
], FadvSelectComponent.prototype, "breakpoint", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvSelectComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fadv-select',
                    template: '<ng-content></ng-content>',
                    providers: [createFormControlProvider(FadvSelectComponent)],
                    inputs: [formControlValueInput, formControlDisabledInput],
                    outputs: [formControlValueOutput, focusEventOutput, blurEventOutput, changeEventOutput],
                }]
        }], ctorParameters: function () {
        return [{ type: i0.ElementRef, decorators: [{
                        type: Inject,
                        args: [ElementRef]
                    }] }];
    }, propDecorators: { variant: [{
                type: Input
            }], name: [{
                type: Input
            }], label: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], helpText: [{
                type: Input
            }], valid: [{
                type: Input
            }], invalid: [{
                type: Input
            }], floating: [{
                type: Input
            }], pill: [{
                type: Input
            }], clearable: [{
                type: Input
            }], hoist: [{
                type: Input
            }], maxTagsVisible: [{
                type: Input
            }], multiple: [{
                type: Input
            }], required: [{
                type: Input
            }], scrollable: [{
                type: Input
            }], native: [{
                type: Input
            }], breakpoint: [{
                type: Input
            }] } });

class FadvSelectModule {
}
FadvSelectModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvSelectModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FadvSelectModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: FadvSelectModule, declarations: [FadvSelectComponent], imports: [FadvCommonModule, FadvCommonModule, FadvMenuModule], exports: [FadvSelectComponent, FadvMenuComponent, FadvMenuItemComponent] });
FadvSelectModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvSelectModule, imports: [FadvCommonModule, FadvCommonModule, FadvMenuModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvSelectModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FadvSelectComponent],
                    imports: [FadvCommonModule, FadvCommonModule, FadvMenuModule],
                    exports: [FadvSelectComponent, FadvMenuComponent, FadvMenuItemComponent],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { FadvSelectComponent, FadvSelectModule };
